import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { QuoteFormEmbed } from "~/components/QuoteFormEmbed";

export const handle = { headerMode: "fleet", footerMode: "fleet", pageTheme: "fleet" };

// The hosted form has its own visible heading; the h1 is for assistive tech,
// which can't see headings inside the cross-origin frame.
export default function FleetQuote() {
  const { t } = useTranslation("fleet");
  const [searchParams] = useSearchParams();

  return (
    <>
      <title>{t("quote.title")}</title>
      <meta name="description" content={t("quote.description")} />
      <h1 className="sr-only">{t("quote.title")}</h1>
      <QuoteFormEmbed title={t("quote.form_title")} qty={searchParams.get("qty")} qid={searchParams.get("qid")} />
    </>
  );
}
